<template>
   <div class="block-edit-process">
       <form id="form-process-add" v-on:submit.prevent="onSave">
        <div class="row"> 
            <div class="col-12 control">
                <ejs-textbox v-model="name" id="name" name="name" :multiline="false" floatLabelType="Auto" cssClass="form-control e-outline" :placeholder="$t('textProcessesStructure.textName')" :data-required-message="$t('textProcessesStructure.textErrorName')" data-msg-containerid="nameError"></ejs-textbox>
                <div id="nameError" ref="nameError"></div>
            </div>
            <div class="col-12 control">
                <ejs-textbox v-model="clasification" id="classification" name="classification" ref='classification' :multiline="false" floatLabelType="Auto" cssClass="form-control e-outline" :placeholder="$t('textProcessesStructure.textClassification')" :data-required-message="$t('textProcessesStructure.textErrorClassification')" data-msg-containerid="classificationError"></ejs-textbox>
                <div id="classificationError" ref="classificationError"></div>
            </div>
            <div class="col-12 control">
                <ejs-autocomplete id="responsable" ref='responsable' name="responsable" v-model="responsable" floatLabelType="Auto" :dataSource='dataSourceUsersTeamQuery' :fields='fieldsUsersTeamQuery' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textProcessesStructure.textResponsable')" :data-required-message="$t('textProcessesStructure.textErrorResponsable')" data-msg-containerid="responsableError" suggestionCount="10000" :change='changeResponsable'></ejs-autocomplete>
                <div id="responsableError" ref="responsableError"></div>
            </div>
            <div class="col-12 control" style="margin-bottom: 2px;">
                <ejs-textbox v-model="description" id="description" name="description" :multiline="true" floatLabelType="Auto" cssClass="form-control e-outline" :placeholder="$t('textProcessesStructure.textDescription')" :data-required-message="$t('textProcessesStructure.textErrorDescription')" data-msg-containerid="descriptionError"></ejs-textbox>
                <div id="descriptionError" ref="descriptionError"></div>
            </div>
            <div class="col-12 text-center control userList">
                <div class="userSelect"><ejs-autocomplete id="teamListSelect" ref='teamListSelect' v-model="teamListSelect" floatLabelType="Auto" :dataSource='dataSourceUsersTeamQuery' :fields='fieldsUsersTeamQuery' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textProcessesStructure.textTeam')" suggestionCount="10000"></ejs-autocomplete></div>
                <div class='btn-add'><span id="teamListAdd" class='btn-add-child' v-on:click='addTeam'></span></div>
                <ejs-listbox id="teamList" :dataSource='dataSourceUsersTeamQuery' scope="#queryList" :fields="fieldsListUsersSelected" :change="selectTeamQuery"></ejs-listbox>
            </div>
            <div class="col-12 text-center control userList">
                <div class="userSelect"><ejs-autocomplete id="queryListSelect" ref='queryListSelect' v-model="queryListSelect" floatLabelType="Auto" :dataSource='dataSourceUsersTeamQuery' :fields='fieldsUsersTeamQuery' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textProcessesStructure.textQuery')" suggestionCount="10000"></ejs-autocomplete></div>
                <div class='btn-add'><span id="queryListAdd" class='btn-add-child' v-on:click='addQuery'></span></div>
                <ejs-listbox id="queryList" :dataSource='dataSourceUsersTeamQuery' :fields="fieldsListUsersSelected" scope="#teamList" :change="selectTeamQuery"></ejs-listbox>
            </div>
            <div class="col-12 control">
                <hr />
                <ejs-multiselect
                 v-model="selectedUsersEspecialAlerts" 
                 id="usersEspecialAlerts"
                 cssClass="e-outline" 
                 mode="Box"
                 :dataSource="dataUsersEspecialAlerts" 
                 :fields="{text: 'user_name', value: 'user_id' }"
                 placeholder="Usuarios Alertas Especiales"
                />
                <small><b>Alertas especiales:</b> Los usuarios seleccionados, podrán recibir notificación de alerta de vencimiento, vencido y ejecutado</small>
                <br />
            </div>
            <div class="col-4 control">
                <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormProcess" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="10000">{{ $t('textProcessesStructure.textSave') }}</ejs-progressbutton>
            </div>
        </div>
      </form>
   </div>
</template>

<script>
import axios from 'axios'
import { Page, Sort, ExcelExport, Toolbar, Search, GridPlugin, Filter } from "@syncfusion/ej2-vue-grids";
import { ListBoxPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { Predicate, Query } from '@syncfusion/ej2-data';
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { DialogUtility } from '@syncfusion/ej2-popups';
Vue.use(ProgressButtonPlugin);
Vue.use(ListBoxPlugin);
Vue.use(ButtonPlugin);

export default {
   name: "processes-detail-edit-process",
   props: ["data"],
   components: {
        DialogUtility,
    },
	data () {
		return {
            name: '',
            clasification: '',
            description: '',
            responsable: '',
            teamListSelect: '',
            queryListSelect : '',
            responsableItem : null,
            dataSourceUsersTeamQuery : [],
            disabledButton :false,
            spinSettings: { position: 'Right', width: 20 },
            optionsFormProcess: {
                rules: {
                    'name': {	
                        required: [true, "* Campo nombre requerido."]
                    },	
                    'classification': {	
                        required: [true, "* Campo clasificación requerido."],
                    },
                    'responsable': {	
                        required: [true, "* Campo responsable requerido."]
                    },
                    'description' : {
                        required: [true, "* Campo descripción requerido."]
                    }
                }
            },
            fieldsUsersTeamQuery : {value: 'user_name', iconCss: 'iconDeleteCss' },
            fieldsListUsersSelected: { text: "user_name", value: 'user_id', iconCss: 'iconDeleteCss'},
            selectedUsersEspecialAlerts: [],
            dataUsersEspecialAlerts: [],
        }
    },
    mounted: function () {
        this.formObjProcess = new FormValidator('#form-process-add', this.optionsFormProcess);
    },
	methods: {
		initEditProcess: function() {
            this.name = ((this.data !== null) ? this.data.nombre : '');
            this.clasification = ((this.data !== null) ? this.data.clasificacion : '');
            this.description = ((this.data !== null) ? this.data.descripcion : '');

            axios.post('/auth/processes/getStructureProcessesUsers', {processId: ((this.data !== null) ? this.data.id : 0)}).then(response => {
                this.dataSourceUsersTeamQuery = response.data;

                this.responsable = ((this.data !== null) ? this.data.responsable : null);
                let responsableList = document.getElementById('responsable').ej2_instances[0];
                let predicateResponsable = new Predicate('type', 'equal', null);
                predicateResponsable = predicateResponsable.or('type', 'equal', 'RESPONSABLE');
                responsableList.query = new Query().where(predicateResponsable);

                let teamList = document.getElementById('teamList').ej2_instances[0];
                let predicateTeam = new Predicate('type', 'equal', 'EQUIPO');
                teamList.query = new Query().where(predicateTeam);

                let queryList = document.getElementById('queryList').ej2_instances[0];
                let predicateQuery = new Predicate('type', 'equal', 'CONSULTA');
                queryList.query = new Query().where(predicateQuery);

                let teamSelect = document.getElementById('teamListSelect').ej2_instances[0];
                let querySelect = document.getElementById('queryListSelect').ej2_instances[0];
                let predicateTeamQuerySelect = new Predicate('type', 'equal', null);
                teamSelect.query = new Query().where(predicateTeamQuerySelect);
                querySelect.query = new Query().where(predicateTeamQuerySelect);

                this.loadUsersEspecialAlerts(response.data);
            });
        },
        changeResponsable: function(args){
            if (args.itemData === null) return;

            if(this.responsableItem == null){
                this.responsableItem = args.itemData;
            }
            if(typeof args.itemData.type === 'undefined'){
                this.responsableItem.type = null;
            }
            else{
                this.responsableItem.type = null;
                args.itemData.type = "RESPONSABLE";
                this.responsableItem = args.itemData;

                // Agrega usuarios disponibles a la lista de alertas especiales
                this.addToDataUsersEspecialAlerts(this.responsableItem);
            }
        },
        selectTeamQuery: function(args){
            //Elimina Item
            let dat = {'info':args.items[0],'proceso_id':this.data.id};
            axios.post('/auth/processes/setValidateTeam', {
                data: dat,
            }).then(response => {
                console.log(response.data)
                if(response.data.status=='ok'){
                    console.log('Si puedes borarlo')
                    if(args.event.srcElement.className == 'e-list-icon e-delete-icon'){
                        args.items[0].type = null;
                        document.getElementById('teamList').ej2_instances[0].refresh();
                        document.getElementById('queryList').ej2_instances[0].refresh();
                    }
                }else{
                     DialogUtility.confirm({
                         title: 'información',
                         content: response.data.info,
                          okButton: {  text: 'Entiendo', click: this.okClick },
                          closeOnEscape: false,
                         });
                }
            });
            
        },
        addTeam: function(args){
            var selectTeam = document.getElementById('teamListSelect').ej2_instances[0].itemData;
            selectTeam.type = 'EQUIPO';
            this.teamListSelect = "";
            this.queryListSelect = "";
            document.getElementById('teamList').ej2_instances[0].refresh();
            document.getElementById('queryList').ej2_instances[0].refresh();

            // Agrega usuarios disponibles a la lista de alertas especiales
            this.addToDataUsersEspecialAlerts(selectTeam);
        },
        addQuery: function(args){
            var selectQuery = document.getElementById('queryListSelect').ej2_instances[0].itemData;
            selectQuery.type = 'CONSULTA';
            this.teamListSelect = "";
            this.queryListSelect = "";
            document.getElementById('teamList').ej2_instances[0].refresh();
            document.getElementById('queryList').ej2_instances[0].refresh();

            // Agrega usuarios disponibles a la lista de alertas especiales
            this.addToDataUsersEspecialAlerts(selectQuery);
        },
        onSave: function(){
            let formStatus = this.formObjProcess.validate();
            if (formStatus) 
            {
                this.disabledButton = true;

                let object = new FormData();
                object.append('name', this.name);
                object.append('clasification', this.clasification);
                object.append('description', this.description);
                object.append('responsable', this.responsableItem.user_id);
                var selectTeam = document.getElementById("teamList").ej2_instances[0].getItems();
                var team = [];
                Object.values(selectTeam).forEach(val => {
                    team.push(val.getAttribute('data-value'));
                });
                object.append('teamUsers', team);
                var selectQuery = document.getElementById("queryList").ej2_instances[0].getItems();
                var query = [];
                Object.values(selectQuery).forEach(val => {
                    query.push(val.getAttribute('data-value'));
                });
                object.append('queryUsers' ,query);
                object.append('selectedUsersEspecialAlerts', this.selectedUsersEspecialAlerts);
                Vue.prototype.$eventHub.$emit('onShowSpinner');
                axios.post('/auth/processes/store/' + ((this.data !== null) ? this.data.id : 0), object).then(response => {
                    this.formObjProcess.element.reset();
                    Vue.prototype.$eventHub.$emit('closeSidebarClick');
                    Vue.prototype.$eventHub.$emit('onInitProcessStructure');
                    Vue.prototype.$eventHub.$emit('onHideSpinner');
                });
            }
        },
        onCancel: function(){
            Vue.prototype.$eventHub.$emit('closeSidebarClick');
        },
        progress: function() {
            if(this.disabledButton == false){
                this.$refs.progressBtnFormProcess.stop();
            }
        },
        addToDataUsersEspecialAlerts: function(el) {
            if (el === null) return
            if (!this.dataUsersEspecialAlerts.findIndex(item => item.user_id === el.user_id) === -1) return
            
            // agregar el usuario a la lista de alertas especiales
            this.dataUsersEspecialAlerts.push({
                user_id: el.user_id,
                user_name: el.user_name,
                type: el.type
            })

            document.getElementById('usersEspecialAlerts').ej2_instances[0].refresh();
        },
        loadUsersEspecialAlerts: async function(data) {
            await this.$nextTick();
            
            // carga todos los usuarios disponibles para alertas especiales
            let users = data.filter(item => item.type !== null).map(item => {
                return {
                    user_id: item.user_id,
                    user_name: item.user_name,
                    type: item.type
                }
            });

            // quita los repetidos user_id
            users = users.filter((item, index, self) => self.findIndex(t => t.user_id === item.user_id) === index);
            this.dataUsersEspecialAlerts = users;

            // preseleccionar los usuarios que tienen alertas especiales sin repetir
            this.selectedUsersEspecialAlerts = data.filter(item => item.special_alerts === 1).map(item => item.user_id)
        },
	},
	created: function() {
        this.initEditProcess();
        this.$eventHub.$on('onResetSwitchTenants', this.onCancel);
    },
}
</script>